import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { RadarSeriesChart } from '@euler/lib/charts/RadarSeriesChart';
import { CoachingProfileArea } from '@euler/model/coaching-progress';
import { memo, useMemo, useState } from 'react';
import { View } from 'react-native';
import { aiColors } from '../../../ai-suite/theme';

/** All eight areas; one never practised sits at the centre, 还没练过. */
export const ProfileRadar = memo(
  ({ areas }: { areas: CoachingProfileArea[] }) => {
    const { rpx } = useResponsiveContext();
    const [width, setWidth] = useState(0);
    const series = useMemo(
      () => [
        {
          key: 'profile',
          color: aiColors.primary,
          values: areas.map(x => x.score ?? undefined),
        },
      ],
      [areas],
    );
    const size = Math.min(width, rpx(320));
    const unpractised = areas.filter(x => x.score == null);
    return (
      <View style={{ gap: rpx(8) }}>
        <View
          style={{ alignItems: 'center' }}
          onLayout={event => setWidth(event.nativeEvent.layout.width)}
        >
          {size > 0 ? (
            <RadarSeriesChart
              width={size}
              height={size}
              spokes={areas.map(x => x.name)}
              series={series}
              perSeries={false}
              scaleFloor={100}
              fillOpacity={0.18}
              dataLabels={false}
              format={value => String(Math.round(value))}
              theme={{
                axisText: aiColors.mutedForeground,
                axisTitle: aiColors.mutedForeground,
                axisLine: aiColors.border,
                grid: aiColors.border,
                label: aiColors.foreground,
                background: aiColors.card,
                fontSize: rpx(11),
              }}
            />
          ) : null}
        </View>
        {unpractised.length ? (
          <Typography.Text
            size={rpx(12)}
            color={aiColors.mutedForeground}
            style={{ textAlign: 'center' }}
          >
            {`还没练过：${unpractised.map(x => x.name).join('、')}`}
          </Typography.Text>
        ) : null}
      </View>
    );
  },
);
